export enum NotificationsFilters {
  Read = 'read',
  Unread = 'unread',
  All = 'all',
}
